/* FifteenFold premium horizontal product rail. No dependencies or product form changes. */
(function(){
'use strict';
function setup(rail){
  var section=rail.closest('.he-featured--rail');
  if(!section)return;
  var prev=section.querySelector('[data-he-rail-prev]');
  var next=section.querySelector('[data-he-rail-next]');
  if(!prev||!next)return;
  function status(){
    var max=Math.max(0,rail.scrollWidth-rail.clientWidth);
    prev.disabled=rail.scrollLeft<=2;
    next.disabled=rail.scrollLeft>=max-2;
  }
  function shift(dir){
    var first=rail.querySelector('.he-card');
    if(!first)return;
    var gap=parseFloat(window.getComputedStyle(rail).columnGap)||0;
    var step=first.getBoundingClientRect().width+gap;
    rail.scrollBy({left:dir*step,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }
  prev.addEventListener('click',function(){shift(-1)});
  next.addEventListener('click',function(){shift(1)});
  rail.addEventListener('scroll',status,{passive:true});
  window.addEventListener('resize',status,{passive:true});
  status();
}
document.querySelectorAll('[data-he-product-rail]').forEach(setup);
})();
